import React, { useEffect, useState } from "react";
import { GoEye, GoEyeClosed } from "react-icons/go";
import axios from "axios";

import "../../_css/Login.css";
import { getOtp, googleLogin, loginUser, resetPassword } from "../../requests";
import {
  getFormattedEmail,
  isValidEmail,
  isValidPassword,
  notifyError,
  notifySuccess,
  saveAuthToken,
} from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { GoogleLogin } from "@react-oauth/google";
import { setUserInformation } from "../../_store/reducers/userReducer";

const Login = () => {
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [conpassword, setConPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordCon, setShowPasswordCon] = useState(false);
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);

  const navigate = useNavigate();

  let loginAudio;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    // prepare audio during user gesture
    loginAudio = new Audio("/loginSound.wav");
    loginAudio.load();

    dispatch(startLoader());

    try {
      const res = await loginUser({ email, password });

      if (res.status < 400) {
        // Now actually play because file is unlocked

        notifySuccess(res.data.message || "Logged in successfully");
        saveAuthToken(JSON.stringify(res.data.token));

        const user = await res.data.user;
        localStorage.setItem("ACCOUNT_STATUS", user?.status);

        loginAudio.play();
        await new Promise((resolve) => setTimeout(resolve, 2000));

        if (user.status == 7) {
          window.location.href = "/teacher-management";
        } else {
          window.location.href = "/";
        }
      }
    } catch (error) {
      notifyError(
        error.response?.data?.error ||
          "Something went wrong. Please try again after some time"
      );
    } finally {
      dispatch(stopLoader());
    }
  };

  const sendCode = async (e) => {
    e.preventDefault();
    if (!validateSendCode()) {
      return;
    }

    dispatch(startLoader());

    try {
      const res = await getOtp({ email, otp, otp_type: "email_verification" });
      // console.log(res.data);

      if (res.status < 400) {
        if (step == 2) {
          setStep(3);
        } else {
          setStep(4);
        }
      }
    } catch (error) {
      notifyError(
        error?.response?.data?.error ||
          "Something went wrong. Please try again after some time"
      );
    } finally {
      dispatch(stopLoader());
    }
  };

  const changePassword = async (e) => {
    if (!validateSendCode()) {
      return;
    }
    dispatch(startLoader());

    try {
      const res = await resetPassword({ email, password });

      if (res.status < 400) {
        notifySuccess(res?.data?.message || "Password updated successfully");
        setStep(1);
        setPassword("");
        setConPassword("");
        setOtp("");
        setEmail("");
      }
    } catch (error) {
      notifyError(
        error?.response?.data?.error ||
          "Something went wrong. Please try again after some time"
      );
    } finally {
      dispatch(stopLoader());
    }
  };

  const validateSendCode = () => {
    if (isNotificationVisible) return;

    notify_visibility(2000);
    if (!email) {
      notifyError("Please enter an email address");
      return false;
    }
    if (!isValidEmail(email)) {
      notifyError("Please enter a valid email address");
      return false;
    }
    //OTP validation
    if (step == 3 && !otp) {
      notifyError("Please enter a OTP");
      return false;
    }

    if (step == 3 && otp.length != 6) {
      notifyError("Please enter a 6 digit OTP");
      return false;
    }

    //Password Validation
    if (step == 4 && (!password || !conpassword)) {
      notifyError("Please enter both password and confirm password");
      return false;
    }

    if (step == 4 && !isValidPassword(password)) {
      notifyError("Please enter a strong password");
      return false;
    }

    if (step == 4 && password != conpassword) {
      notifyError("Password and confirm password were not matching.");
      return false;
    }

    return true;
  };

  const validate = () => {
    if (isNotificationVisible) return;

    notify_visibility(2000);

    if (!email && !password) {
      notifyError("Please enter email and password");
      return false;
    }

    // Email validation
    if (!email) {
      notifyError("Please enter an email address");
      return false;
    }

    if (!isValidEmail(email)) {
      notifyError("Please enter a valid email address");
      return false;
    }

    // Password validation
    if (!password) {
      notifyError("Please enter a password");
      return false;
    }

    if (password.length < 3) {
      notifyError("Please enter a password of least 8 characters long");
      return false;
    }

    return true;
  };

  const notify_visibility = (timer) => {
    if (isNotificationVisible) return;

    setIsNotificationVisible(true);

    setTimeout(() => {
      setIsNotificationVisible(false);
    }, timer);
  };

  const loginwithGoogle = async (res) => {
    // prepare audio during user gesture
    loginAudio = new Audio("/loginSound.wav");
    loginAudio.load();

      dispatch(startLoader());

    try {
      const response = await googleLogin({ credential: res.credential });

      if (response.status < 400) {
        // Now actually play because file is unlocked
        notifySuccess(response?.data?.message || "Logged in successfully");
        saveAuthToken(JSON.stringify(response?.data?.token));

        const user = await response?.data?.user;
        localStorage.setItem("ACCOUNT_STATUS", user?.status);

        loginAudio.play();
        await new Promise((resolve) => setTimeout(resolve, 2000));

        if (user.status == 7) {
          window.location.href = "/teacher-management";
        } else {
          
          window.location.href = "/";
        }
      }
    } catch (error) {
      console.log(error);
      notifyError(
        error.response?.data?.error ||
          "Something went wrong. Please try again after some time"
      );
    }
    finally {
      dispatch(stopLoader());
    }
  };

  const resendCode = async () => {
    setStep(2);
    setOtp("");
  };
 

  return (
    <div className="login-main center-div">
      {step == 1 && (
        <div className="login-container">
          <div className="login-header">
            <div className="login-header-text">Welcome Back!</div>
            <div className="login-header-subtext">
              Use your email or another service to continue
            </div>
          </div>

          <form className="login-form">
            <div className="login-form-section1">
              <div className="login-input-area">
                <label className="login-form-label">Email</label>
                <input
                  className="login-form-input"
                  type="email"
                  placeholder="example@domain.com"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div
                className="login-input-area"
                style={{ position: "relative" }}
              >
                <label className="login-form-label">Password</label>
                <input
                  className="login-form-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "70%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6B7280",
                  }}
                >
                  {" "}
                  {showPassword ? <GoEye /> : <GoEyeClosed />}
                </span>
              </div>
            </div>
            <div className="login-form-section2">
              <button onClick={handleSubmit} className="login-form-button">
                Continue to SWISH AI
              </button>
              <div
                onClick={() => (
                  setStep(2),
                  setEmail(""),
                  setPassword(""),
                  setConPassword(""),
                  setOtp("")
                )}
                className="login-form-forgot"
              >
                Forgot password?
              </div>
            </div>
          </form>

          <div className="login-partition ">
            <div className="login-vector"></div>
            <div className="login-partition-text">or</div>
            <div className="login-vector"></div>
          </div>
          <div className="google-login">
            {/* <div className="login-con-google">
              <div className="login-con-text">Continue with Google</div>
            </div> */}
            <GoogleLogin
              onSuccess={(res) => loginwithGoogle(res)}
              onError={() => {
                console.log("Login Failed");
              }}
            />
            <div className="login-signup-button">
              <div className="login-signup-text">Don't have an account?</div>
              <span
                onClick={() => navigate("/signup")}
                className="login-signup-span"
              >
                Sign up
              </span>
            </div>
          </div>
        </div>
      )}
      {step == 2 && (
        <div className="forgot-container">
          <div className="forgot-password-head">
            <div className="login-header-text">Enter Email to Get Code</div>
          </div>
          <div className="forgot-password-body">
            <div className="forgot-password-form">
              <div className="login-input-area">
                <label className="login-form-label">Email</label>
                <input
                  className="login-form-input"
                  type="email"
                  placeholder="example@domain.com"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="forgot-password-submit">
              <button onClick={sendCode} className="login-form-button">
                Send Code
              </button>
              <div onClick={() => setStep(1)} className="login-form-forgot">
                Back to Login
              </div>
            </div>
          </div>
        </div>
      )}
      {step == 3 && (
        <div className="forgot-container">
          <div className="forgot-password-head">
            <div className="login-header-text">Enter a Verification code</div>
            <div className="login-header-subtext">
              Code sent to {getFormattedEmail(email)}
            </div>
          </div>
          <div className="forgot-password-body">
            <div className="forgot-password-form">
              <div className="login-input-area">
                <label className="login-form-label">Enter Code</label>
                <input
                  className="login-form-input no-spinner"
                  type="number"
                  placeholder="Code"
                  name="otp"
                  onInput={(e) => {
                    if (e.target.value.length > 6) {
                      e.target.value = e.target.value.slice(0, 6);
                    }
                  }}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </div>
            </div>
            
            <div className="forgot-password-submit" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <div onClick={resendCode} className="login-form-forgot">Go back</div>
              <button style={{backgroundColor: "#0DB9EA", color: "white", border: "none", borderRadius: "5px", padding: "5px 10px", cursor: "pointer"}} onClick={sendCode} className="login-form-button">
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {step == 4 && (
        <div className="forgot-container">
          <div className="forgot-password-head">
            <div className="login-header-text">Reset Password</div>
            <div className="login-header-subtext">
              Code sent to {getFormattedEmail(email)}
            </div>
          </div>
          <div className="forgot-password-body">
            <div className="forgot-password-form">
              <div
                className="login-input-area"
                style={{ position: "relative" }}
              >
                <label className="login-form-label">New Password</label>
                <input
                  className="login-form-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "70%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6B7280",
                  }}
                >
                  {" "}
                  {showPassword ? <GoEye /> : <GoEyeClosed />}
                </span>
              </div>
              <div
                className="login-input-area"
                style={{ position: "relative" }}
              >
                <label className="login-form-label">Confirm Password</label>
                <input
                  className="login-form-input"
                  type={showPasswordCon ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={conpassword}
                  onChange={(e) => setConPassword(e.target.value)}
                />
                <span
                  onClick={() => setShowPasswordCon((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "70%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6B7280",
                  }}
                >
                  {" "}
                  {showPasswordCon ? <GoEye /> : <GoEyeClosed />}
                </span>
              </div>
            </div>
            <div className="forgot-password-submit">
              <button onClick={changePassword} className="login-form-button">
                Reset Password
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
